import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { COMPANY, SERVICES } from "@/data/content";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-offwhite border-t border-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <Logo />
            <p className="mt-5 text-sm text-charcoal-mute leading-relaxed max-w-xs">
              A UK creative design agency delivering specialised design services —
              branding, graphic design, packaging, website layouts and digital
              content — with clarity, consistency and care.
            </p>
          </div>

          <nav className="lg:col-span-2" aria-label="Footer">
            <h3 className="eyebrow mb-5">Explore</h3>
            <ul className="space-y-3 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/services", label: "Services" },
                { to: "/portfolio", label: "Portfolio" },
                { to: "/contact", label: "Contact" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-charcoal-mute hover:text-gold-deep transition-colors duration-200"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav className="lg:col-span-3" aria-label="Services">
            <h3 className="eyebrow mb-5">Services</h3>
            <ul className="space-y-3 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services#${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-charcoal-mute hover:text-gold-deep transition-colors duration-200"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="lg:col-span-3">
            <h3 className="eyebrow mb-5">Contact</h3>
            <ul className="space-y-3 text-sm text-charcoal-mute">
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  data-testid="footer-email-link"
                  className="hover:text-gold-deep transition-colors duration-200 break-all"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone-link"
                  className="hover:text-gold-deep transition-colors duration-200"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="leading-relaxed" data-testid="footer-address">
                {COMPANY.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-charcoal-mute" data-testid="footer-copyright">
            © {year} SSDE LTD. All rights reserved. Registered in England &amp; Wales.
          </p>
          <div className="flex items-center gap-6 text-xs">
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="text-charcoal-mute hover:text-gold-deep transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="text-charcoal-mute hover:text-gold-deep transition-colors duration-200"
            >
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
